import React, { Component } from "react";
import UserSegments from "../UserSegments";
import UserSegment from "../UserSegment";
import NewUserSegment from "../NewUserSegment";
import { Switch, Route, withRouter } from "react-router-dom";

export class App extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/knowledge/user_segments" component={UserSegments} />
        <Route
          exact
          path="/knowledge/user_segments/new"
          component={NewUserSegment}
        />
        <Route
          exact
          path="/knowledge/user_segments/:type(staff|signedIn)/:page?"
          component={UserSegments}
        />
        <Route
          exact
          path="/knowledge/user_segments/:id"
          component={UserSegment}
        />
      </Switch>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/components/App/index.js